function removeSingleFacetValue(facets, fieldName, value) {
	return facets.reduce((acc, facet) => {
		const { field, values } = facet

		if (field === `f_${fieldName}`) {
			const updatedFacetValues = values.filter(facetValue => facetValue !== value)

			if (updatedFacetValues.length > 0) {
				return acc.concat({
					field,
					values: updatedFacetValues,
				})
			}
			return acc
		}

		return acc.concat(facet)
	}, [])
}

export default function removeFacet(name, value) {
	const { facets } = this.state

	let updatedFilters = facets

	if (!value) {
	} else if (value) {
		updatedFilters = removeSingleFacetValue(facets, name, value)
	} else {
		updatedFilters = facets.filter(facet => facet.field !== name)
	}

	this._updateSearchResults({
		pageNumber: 1,
		facets: updatedFilters,
	})
}
